import React from 'react';
import { useTranslations } from '@/shared/ui/selects/select-options/hooks';
import { HeadingMediumH5 } from '@/shared/ui/typography2';
import { interpolateTemplate } from '../../utils/interpolate-template';
import { Box } from '@/shared/ui/box/Box';
import { OrangeText } from './styles'

export const WelcomeBonusTitle = () => {
  const { translations } = useTranslations();
  const parts = translations?.bonus?.page_content?.welcome_bonus_title?.parts;

  if (!Array.isArray(parts)) return null;

  return (
    <Box>
      {parts.map((part, index) => (
        <HeadingMediumH5 key={index}>
          {interpolateTemplate(part.template, part.variables, OrangeText)}
        </HeadingMediumH5>
      ))}
    </Box>
  );
};
